// initial state
const state = {
    renew: {
      type: "",
      padCode: "",
    }
  };
  
  // getters
  const getters = {};
  
  // actions
  const actions = {};
  
  // mutations
  const mutations = {
    setRenew(state, renew) {
      //设置参数
      state.renew = renew;
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
  


// WEBPACK FOOTER //
// ./src/store/module/renew.js